import React, { useEffect } from "react";
import { useState } from "react";
import {  Button } from "flowbite-react";
import EventTable from "../components/Table/EventTable"
import NavigationComponent from "../components/Nav_footer/Navigation";
import axios from "axios";
import FooterComponent from "../components/Nav_footer/Footer";
import { useParams } from "react-router-dom";
import EventForm from "../components/Forms/EventForm";

export default function EventPage() {
    const params = useParams()
    const [ShowUploadForm, setShowUploadForm] = useState(false);
    const [List, setList] = useState([]);
    const permission = true
    const mode = params.mode

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_SERVER_URL}/api/events/getAllEvents`, {}, { withCredentials: true })
            .then(result => {
                if (result.status === 200 && result.data.message === "success") {
                    setList(result.data.data)
                }
            }).catch(err => {
                if (err.response.status === 401) {
                    return window.location.href = "/login"
                }
                if (err.response.status === 403) {
                    return window.location.href = "/"
                }
                console.log(err)
            })
    }, [])

    return (
        <>
            {ShowUploadForm && <EventForm props={{ ShowUploadForm, setShowUploadForm, List, setList,permission }} />}
            <NavigationComponent />
            <div className="mt-8 my-5">

                <div className="text-center"> <h1 className="font-bold mb-10">Event Table</h1></div>
                <EventTable data={{ List,mode}} />
                <div>
                    <div className="flex gap-3 w-fit m-auto mt-10">


                        <div className="items-center m-1" >
                            {mode === "edit" && <Button
                                // disabled= {mode}
                                onClick={() => setShowUploadForm(true)}>
                                Add
                            </Button>}

                        </div>


                    </div>
                </div>
            </div>
            <div className="relative bottom-0 text-center p-8  w-full">
      
                <FooterComponent />
            </div>

        </>
    )
}